<script>
  import VueQr from 'vue-qr'
  import { getClientMap } from '../hooks/config'

  export default {
    name: 'QrLoad',
    components: {
      VueQr
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      qrCodeUrl: {
        type: String,
        default: ''
      },
      qrCodeData: {
        type: Object,
        default: null
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data() {
      return {
        loading: false
      }
    },
    computed: {
      visible: {
        get() {
          return this.value
        },
        set(newVal) {
          this.$emit('change', newVal)
        }
      }
    },
    methods: {
      handleClose() {
        this.visible = false
      },
      downloadQrCodeFunc() {
        if (!this.qrCodeData || !this.qrCodeData.shortUrl) return
        this.loading = true
        // 获取二维码DOM元素并导出为图片
        const qrcodeElement = document.getElementById('qrcodeBox')
        const image = qrcodeElement.getElementsByTagName('img')[0]
        if (!image) return

        // 使用html2canvas将二维码容器转换为canvas
        import('html2canvas').then((html2canvas) => {
          html2canvas.default(image).then((canvas) => {
            // 将canvas转换为图片URL
            const imgUrl = canvas.toDataURL('image/png')

            const { name, client, appName } = this.qrCodeData

            const clientName = getClientMap({ client })

            // 创建下载链接
            const link = document.createElement('a')
            link.href = imgUrl
            link.download = `${name || ''} ${clientName || ''} ${appName || ''}.png`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            this.loading = false
          })
        })
      }
    }
  }
</script>

<template>
  <div class="qr-code-modal" v-if="visible">
    <div class="modal-content">
      <div class="qr-code-container" id="qrcodeBox">
        <vue-qr v-if="qrCodeData.shortUrl" :text="qrCodeData.shortUrl" :size="300" :margin="0" />
        <div class="qr-code-placeholder" v-else></div>
      </div>
      <div class="button-container">
        <el-button class="download-btn" v-loading="loading" @click="downloadQrCodeFunc"
          >下载二维码</el-button
        >
        <button class="close-btn" @click="handleClose">关闭</button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .qr-code-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 4px;
    width: 400px;
    max-width: 90%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .qr-code-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    padding: 10px 0;
  }

  .qr-code-img {
    width: 200px;
    height: 200px;
    object-fit: contain;
  }

  .qr-code-placeholder {
    width: 200px;
    height: 200px;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
  }

  .button-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .download-btn {
    background-color: #1e9fff;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 10px 0;
    cursor: pointer;
    font-size: 14px;
  }

  .close-btn {
    background-color: white;
    color: #666;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px 0;
    cursor: pointer;
    font-size: 14px;
  }
</style>
